import { enumToTitleCase } from '../../../../../../../utils/formatting';
import type { ErrorItem } from '../../../types';

export const getErrorHeader = (error: ErrorItem): string => {
  return `${enumToTitleCase(error.errorCode)} (${error.itemIds.length})`;
};
